import React, { useState } from 'react'
import { Row, Col, Table, Button, Form, FormControl } from 'react-bootstrap'
import { FetchCreateBoutiqueTransaction } from '../../fetcher'
import { ModalComponent } from '../presentational-components/ModalComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import NewSale from './NewSale'
import {Redirect} from 'react-router-dom'

const PayProcess = ({ paymentList, transactions, date, handleClose, handleRedirect, reload, area, setTaskName, setIsCreating }) => {
    const [payment, setPayment] = useState(null)

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    //const redirect = () => {
    //    return (
    //        <Redirect to="/authentication" />
    //    )
    //}
    //const handleShowTransactions = () => {
    //    return (
    //        //redirect()
    //    )
    //}

    const handleSubmit = (e) => {
        e.preventDefault()
        console.log("Sale handleSubmit", transactions)
        const TransactionsToCreate = []
        transactions.forEach(x => TransactionsToCreate.push({ ArticleTypeSysId: x.articleType.ArticleTypeSysId, SizeValue: x.size.SizeValue, Amount: x.number, Remarks: x.remarks, PriceAtTimeOfSale: parseFloat(x.articleType.PriceUnit) + parseFloat(x.discount)}))
        const BoutiqueSaleTransactionsListToCreate = {
            Payment: payment,
            SerializedTransactionData: JSON.stringify(TransactionsToCreate),
            DateOfSale: date.toISOString()
        }
        console.log(BoutiqueSaleTransactionsListToCreate)

        setTaskName("Die Verkaufstransaktion wird gespeichert")
        FetchCreateBoutiqueTransaction(BoutiqueSaleTransactionsListToCreate, reload, openAlert, handleClose, handleRedirect, area, setIsCreating)

        //showAlertMessage ? console.log("") : handleRedirect()
        //showAlertMessage ? console.log("") : handleClose()
    }

    return (
        <div>
            <Form onSubmit={handleSubmit} id='boutique-payprocess-form'>
                <p>Bitte wählen Sie eine Zahlungsmethode und bestätigen Sie anschließend die Buchung.</p>

                <FormControl as="select" onChange={(e) => setPayment(e.target.value)}>
                    <option defaultValue selected disabled>Zahlungsmittel</option>
                    {paymentList.map(payment =>
                        <option>{payment}</option>
                    )}
                </FormControl>
            </Form>

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export default PayProcess